import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';

import Header from './Header'
import ChatBody from './Chat/ChatBody';
import ChatFooter from './Chat/ChatFooter/ChatFooter';
import NewConversationButton from './NewConversationButton';
import {TicketModel, CustomizationModel} from '/chat/src/redux/model';
import StarRating from './Rating';


class Chat extends Component{
    constructor(props){
        super(props)
        this.state = {
            isResolved: false,
        }
    }

    componentWillUnmount(){
        //this.props.dispatch(TicketModel.setCurrentRoom(''))
    }

    componentDidMount(){
        if(this.props.room){ // because of cookie
            this.props.dispatch(TicketModel.requestEntriesGet(this.props.room))
            if(this.props.unread){
                this.props.dispatch(TicketModel.requestSetTicketToRead(this.props.room))
            }
        }
    }

    renderNewConversationButton(){
        if(!this.props.ticket) return;
        if(this.props.ticket.get('is_resolved'))
            return <NewConversationButton/>
        return null;
    }

    renderRating(){
        if(!this.props.ticket) return;
        if(this.props.ticket.get('is_resolved'))
            return <StarRating/>
        return null;
    }

    render(){
        return (
            <div>
                {this.props.ratingOn ? this.renderRating(): null /*Only render stars if rating feature is turned on*/}
                <ChatBody />
                <ChatFooter />
                {this.renderNewConversationButton()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const ratingOn = CustomizationModel.getRatingStatus(state)
    const room = TicketModel.getCurrentRoom(state)
    const ticket = TicketModel.get(room , state)
    const unread = TicketModel.getUnread(room, state)

    return { ratingOn, room, ticket, unread };
}

export default connect(mapStateToProps)(Chat);



// WEBPACK FOOTER //
// ./routes/Chat/Body.js